import FRectBtn from './FRectBtn';
import FCircleBtn from './FCircleBtn';
import FTextBtn from './FTextBtn';

// export {
//   FRectBtn,
//   FCircleBtn,
//   FTextBtn,
// }

export default class FButton {
  public static FCircleBtn = FCircleBtn
}
